<template>
    <v-dialog v-model="visible" persistent max-width="500px">
        <v-card light>
            <v-card-title class="justify-center">
                <v-spacer/>
                <span class="text-h5">
                    {{ form.id ? 'Edição' : 'Cadastro' }} de Categoria
                </span>
                <v-spacer/>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            label="Nome"
                            v-model="form.nome"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            label="Cor"
                            v-model="form.cor"
                            dense
                            outlined
                            placeholder="#1976D2"
                            maxlength="7"
                            :error-messages="erroCor"
                            @blur="normalizarCor"
                        >
                            <template v-slot:append>
                                <v-menu
                                    v-model="menuCor"
                                    :close-on-content-click="false"
                                    offset-y
                                    left
                                    nudge-bottom="10"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <div
                                            class="amostra-cor"
                                            :style="{ background: corSelecionada }"
                                            v-bind="attrs"
                                            v-on="on"
                                        />
                                    </template>
                                    <v-color-picker
                                        v-model="corSelecionada"
                                        mode="hexa"
                                        hide-mode-switch
                                        show-swatches
                                        swatches-max-height="140"
                                    />
                                </v-menu>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="d-flex align-center">
                        <v-switch
                            v-model="form.ativo"
                            label="Ativo"
                            hide-details
                            class="mt-0"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="warning" @click="$emit('close')">Cancelar</v-btn>
                <v-spacer/>
                <v-btn color="success" @click="salvar" :loading="loading">
                    <v-icon>mdi-content-save</v-icon>&nbsp;Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
const COR_PADRAO = '#1976D2';
const HEX = /^#[0-9A-F]{6}$/;

export default {
    name: 'CategoriaForm',

    props: {
        visible: { type: Boolean, default: false },
        formData: { type: Object, default: () => ({}) },
    },

    data: () => ({
        form: {},
        loading: false,
        menuCor: false,
    }),

    computed: {
        corSelecionada: {
            get() {
                return HEX.test(String(this.form.cor || '').toUpperCase())
                    ? this.form.cor.toUpperCase()
                    : COR_PADRAO;
            },
            set(valor) {
                const hex = typeof valor === 'string'
                    ? valor
                    : (valor && (valor.hex || valor.hexa)) || '';

                this.$set(this.form, 'cor', String(hex).slice(0, 7).toUpperCase());
            },
        },

        erroCor() {
            const cor = String(this.form.cor || '').toUpperCase();
            return !cor || HEX.test(cor) ? '' : 'Use o formato #RRGGBB';
        },
    },

    watch: {
        formData(value) {
            this.form = value ? JSON.parse(JSON.stringify(value)) : {};
            this.menuCor = false;
        },
    },

    methods: {
        normalizarCor() {
            const cor = String(this.form.cor || '').trim().toUpperCase();

            if (!cor) {
                return;
            }

            const comHash = cor.startsWith('#') ? cor : `#${cor}`;

            if (HEX.test(comHash)) {
                this.$set(this.form, 'cor', comHash);
            }
        },

        salvar() {
            if (!this.form.nome) {
                alert('Informe o nome da categoria');
                return;
            }

            this.normalizarCor();

            if (this.erroCor) {
                alert('Informe uma cor válida no formato #RRGGBB');
                return;
            }

            const payload = {
                nome: this.form.nome,
                cor: this.form.cor || COR_PADRAO,
                ativo: this.form.ativo !== false,
            };

            this.loading = true;
            const id = this.form.id;
            const req = id
                ? this.$http.put(`financeiro-interno/categorias/${id}`, payload)
                : this.$http.post('financeiro-interno/categorias', payload);

            req.then(() => this.$emit('onCadastro'))
                .catch(e => alert(e?.response?.data?.message || 'Erro ao salvar'))
                .finally(() => (this.loading = false));
        },
    },
}
</script>

<style scoped>
.amostra-cor {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    cursor: pointer;
    margin-top: -2px;
}
</style>
